import React, { Component } from 'react';
import { Row, Col, message, Space, Tabs, Badge } from 'antd';
import { EditOutlined } from "@ant-design/icons";
import { showDelConfirm, getOnOkFunction } from "@/lib/antdElementFunction";
import { getLangList } from '@/lib/i18n';
import { ReButton, ReModal } from '@/components/refineElement';
import BusConfig from "@/config/bus";
import { hasPermission } from "@/lib/permissionUtil";
import StudentList from './StudentList';
import ModalPath from './ModalPath';

const { createSchoolInfo, updateSchoolInfo, deleteSchoolInfo } = BusConfig;
const { TabPane } = Tabs;

interface props {
  allStudentArray: any;
  pathArray: any;
  activeBusTimeId: string;
  getSchoolInfo: any;
  activeDayKey: number;
  constActiveDayKey: number;
  activeTimeArray: number[];
}

interface state {
  isModalVisible: boolean;
  handleType: string;
  activePathId: string;
  pathInfo: any;
}

class Path extends Component<props, state> {
  state = {
    isModalVisible: false,
    handleType: '',
    activePathId: '',
    pathInfo: {} as never as any,
  };
  busT: any = getLangList("bus");
  errorT: any = getLangList("error");
  buttonT: any = getLangList("button");

  componentDidMount() {
    const { pathArray = [] } = this.props;
    const activePathId = `${pathArray[0]?.id ?? ''}`;

    activePathId && this.setState({ activePathId });
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { activePathId } = this.state;
    const { pathArray = [] } = this.props;

    if (prevState.activePathId === '' && activePathId === '' && pathArray.length > 0) {
      const activePathId = `${pathArray[0]?.id ?? ''}`;

      activePathId && this.setState({ activePathId });
    }
  }

  toggleModal = (handleType: string = '') => {
    const { isModalVisible } = this.state;
    this.setState({ isModalVisible: !isModalVisible, handleType });
  }

  clickCreate = () => {
    this.setState({ pathInfo: {} }, () => this.toggleModal('create'));
  }

  clickEdit = (data: object) => (e: any) => {
    e.stopPropagation();
    this.setState({ pathInfo: data }, () => this.toggleModal('update'));
  }

  clickDelete = () => {
    const { activePathId } = this.state;
    showDelConfirm(() => this.deleteSchoolInfo(activePathId));
  };

  createSchoolInfo = (values: any) => {
    const { activeBusTimeId, getSchoolInfo } = this.props;
    const { schoolName } = values;
    const params = {
      schoolName,
      busTimeId: activeBusTimeId,
    };

    createSchoolInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      getSchoolInfo();
    });
  }

  updateSchoolInfo = (values: any) => {
    const { getSchoolInfo } = this.props;
    const { pathInfo } = this.state;
    const { busTimeId, id } = pathInfo;
    const { schoolName } = values;
    const params = {
      schoolName,
      busTimeId,
      id,
    };

    if (!hasPermission('BUS_EDIT')) {
      return message.error(this.errorT.NO_PERMISSION);
    }

    updateSchoolInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      getSchoolInfo();
    });
  }

  deleteSchoolInfo = (id: string) => {
    const { getSchoolInfo, pathArray = [] } = this.props;
    const params = { busTimeSchoolId: id };

    deleteSchoolInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      getSchoolInfo().then(() => this.setState({ activePathId: pathArray?.[0]?.id?.toString() ?? '' }));
    });
  }

  render() {
    const {
      allStudentArray,
      pathArray = [],
      getSchoolInfo,
      activeDayKey,
      constActiveDayKey,
      activeTimeArray,
    } = this.props;
    const { isModalVisible, handleType, activePathId, pathInfo } = this.state;
    const isTodayActiveDayKey = activeDayKey === constActiveDayKey;
    const okFunction = {
      create: this.createSchoolInfo,
      update: this.updateSchoolInfo,
    };

    return (
      <>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Tabs
              activeKey={activePathId}
              onChange={(activeKey: string) => this.setState({ activePathId: activeKey })}
              destroyInactiveTabPane
              tabBarExtraContent={hasPermission('BUS_NEW') &&
                <ReButton iconName='plus' onClick={this.clickCreate}>
                  {`${this.buttonT.NEW}${this.busT.PATH}`}
                </ReButton>
              }
            >
              {pathArray.map((item: any) => {
                const { id, schoolName, rollCallCount, takeBusCount, leaveCount } = item;
                const absentCount = takeBusCount - rollCallCount - leaveCount;

                return (
                  <TabPane
                    key={id}
                    tab={
                      <Space>
                        {schoolName}
                        {activePathId === id.toString() && hasPermission(['BUS_EDIT', 'BUS_DELETE']) &&
                          <span onClick={this.clickEdit(item)}><EditOutlined /></span>
                        }
                        {isTodayActiveDayKey && absentCount > 0 &&
                          <Badge dot />
                        }

                      </Space>
                    }
                  >
                    <StudentList
                      activePathId={activePathId}
                      allStudentArray={allStudentArray}
                      getSchoolInfo={getSchoolInfo}
                      activeTimeArray={activeTimeArray}
                    />
                  </TabPane>
                );
              })}
            </Tabs>
          </Col>
        </Row>

        {isModalVisible &&
          <ReModal
            title={this.busT.SCHOOL}
            onCancel={() => this.toggleModal()}
            visible={isModalVisible}
            onOk={(data: any) => getOnOkFunction(handleType, data, okFunction)}
            CollectedForm={ModalPath}
            formProps={{
              handleType,
              pathInfo,
              clickDelete: this.clickDelete,
            }}
          />
        }
      </>
    );
  }
}

export default Path;